import React from 'react'

const EventIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M124.5.6c-3.5.9-9.8 5.8-12.7 9.9-3.7 5.3-4.8 11.9-4.8 29.1V54H77.7c-31.7 0-35.8.5-46 5.6C19.9 65.5 9.9 77.4 6 89.9c-2 6.2-2 9.8-2 193 0 154.6.3 187.5 1.4 191.7 4.5 16.8 19.2 31.5 36 36 7.6 2 421.6 2 429.2 0 16.8-4.5 31.5-19.2 36-36 1.1-4.2 1.4-37.1 1.4-191.7 0-183.2 0-186.8-2-193-3.9-12.5-13.9-24.4-25.7-30.3-10.2-5.1-14.3-5.6-46.5-5.6H404V36.7c0-16-.2-17.5-2.4-22.2C396.7 4.1 389.6 0 376.8 0c-9.5 0-14.4 1.8-19.6 7-6.3 6.3-6.7 7.7-7 28.2l-.4 18.8H162V39.6c0-7.9-.4-16.7-1-19.5-1.2-6.6-5.3-12.7-11-16.6-4.1-2.7-5.2-3-14-3.1-5.2-.1-10.4 0-11.5.2zM450 316v138H62V178h388v138z"
      />
      <path
        fill={color}
        d="M250.7 209.3c-6.7 2.1-9.5 6-20.5 28.7-5.8 11.8-10.6 21.6-10.7 21.8-.1.1-10.9 1.8-24.1 3.8-26.3 3.9-31 5.4-34.5 11.1-2.6 4.2-3.5 10.9-2 15.4.7 2.3 7.1 9.4 19.4 21.7l18.4 18.4-3.8 22.1c-2.1 12.2-3.9 24.1-3.9 26.5 0 11.5 9.7 19.6 20.7 17.2 2.3-.6 13.7-6 25.3-12l21-11.1 20.8 11c11.4 6 22.5 11.4 24.7 12 7 1.8 14.2-.9 18.9-7.2 3.3-4.5 3.1-12-1.2-36.4l-3.9-22.1 18.4-18.4c12.3-12.3 18.7-19.4 19.4-21.7 1.5-4.5.6-11.2-2-15.4-3.5-5.7-8.2-7.2-34.5-11.1-13.2-2-24-3.7-24.1-3.8-.2-.2-5-10-10.7-21.8-11.3-23.3-14.1-27.1-21.3-28.9-5.1-1.3-4.9-1.3-9.8.2z"
      />
    </svg>
  )
}

EventIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default EventIcon
